module.exports = __webpack_public_path__ + "media/packs/images/flags/BG-742002f199eb253f3c273be8ff08f7bb.svg";